module.exports = {"future":"%s to go","past":"%s ago","s":"a few seconds","ss":"%d seconds","m":"a minute","mm":"%d minutes","h":"an hour","hh":"%d hours","d":"a day","dd":"%d days","M":"a month","MM":"%d months","y":"a year","yy":"%d years"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/moment.en.json
// module id = 667
// module chunks = 1 2